import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectExpenseTypesRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectExpenseTypesRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectExpenseTypesRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getProjectExpenseTypes() {
      return getState().projectExpenseTypes;
    },
  };
}

export { createSelector };
